import swal from "sweetalert2";
import {db} from "@/firebase/init";
export default {
    data() {
        return {
            toast: null,
            isNowIdle: true,
            shiftOutAlertListener: true,
        };
    },
    computed:{
        userUId() {
            return this.$store.getters.getUID;
        },
    },
    async created() {
        this.toast = swal.mixin({})
    },
    methods: {
        async destroyAlertSnapshot(){
            if (this.shiftOutAlertListener) {
                this.shiftOutAlertListener()
            }
        },
        async commenceAlertSnapShot(){
            try {
                const userRef = await db.collection('users').where('shiftOutAlert', '==', true)
                this.idleListener = userRef.onSnapshot(querySnapshot => {
                    querySnapshot.docChanges().forEach(changeDoc => {
                        console.log('Hello', changeDoc.doc.id , this.userUId)
                        if (changeDoc.type === 'added'){
                            if (changeDoc.doc.id === this.userUId) {
                                this.opensShiftOutPopUp()
                            }
                        }
                        else if(changeDoc.type ==='modified'){
                            if (changeDoc.doc.id === this.userUId) {
                                this.opensShiftOutPopUp()
                            }
                        }
                    })
                });
            } catch (e) {
                console.log(e.toString())
            }
        },
        async opensShiftOutPopUp() {
            this.toast.fire({
                html: "<b>Automatic Shift-out Alert!</b> <br><br>Its your time to shift out  <br><br>",
                timer: 60000,
                type: 'info',
                confirmButtonText: "Shift Out",
                reverseButtons: true,

            }).then(async (result) => {
                if (result.value) {
                    try {
                        const resp = await this.$http.post('/utilities/mark-attendance', {
                            grant_type: 'token',
                            user: this.user,
                            type: 'shift-out',
                            message_type:'user-shift-out'
                        });

                        console.log(resp)
                    } catch (e) {
                        console.log(e.toString(), 'Error while inserting it in the queue')
                    }
                }
            });
            await db.collection('users').doc(this.userUId).update({
                shiftOutAlert: false
            })

        },
    }
}
